<template>
  <div class="app-container">
    <!-- <div v-if="classOption.length>1">
        		<span>班级：</span>
				 <el-select v-model="searchObj.classId" placeholder="请选择" @change="changeHanlde">
                  <el-option v-for="item in classOption" :key="item.id" :label="item.text" :value="item.text"> </el-option>
                </el-select>
          </div> -->
		<data-table
    v-if="showView==='listpage'"
    id="targetDiv"
	:module-info="moduleInfo"
	:tb-columns="tbColumns"
	:toolbar-btns="listpageBtns"
	:on-list-data-before-load="onListDataBeforeLoad"
	:on-list-data-loaded="onListDataLoaded"
	:on-delete-successed="onDeleteSuccessed"
	:on-cell-click="openWorkFlow"
>
</data-table>

	<wflow-view v-if="showView==='mainform'"></wflow-view>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
        	showView: 'listpage',
            loginUser: {},
            moduleInfo: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/studentTuitionWaiverApplication/form.html', 'addNewUrl': 'xsgl/studentTuitionWaiverApplication/addNew', 'insertUrl': 'xsgl/studentTuitionWaiverApplication/insert', 'getByIdUrl': 'xsgl/studentTuitionWaiverApplication/getById', 'updateUrl': 'xsgl/studentTuitionWaiverApplication/update', 'delUrl': 'xsgl/studentTuitionWaiverApplication/delete', 'listDataUrl': 'xsgl/studentTuitionWaiverApplication/listdata', 'winWidth': 1000, 'winHeight': 600, 'moduleCode': 'tuitionWaiverApplication', 'openViewType': '1', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0, 'wfEngineUrl': 'xsgl/studentTuitionWaiverApplication', 'busiCode': 'studentTuitionWaiverApplication'},
            tbColumns: [{'field': 'state', 'checkbox': true, 'width': '45px', 'align': 'center', 'sortable': false, 'fixed': 'false'}, {'align': 'center', 'field': 'index', 'title': '序号', 'width': '45px', 'sortable': false, 'fixed': 'false', 'listAdvSearchElement': '', 'searchable': false, 'propType': ''}, {'align': 'center', 'field': 'studentName', 'title': '姓名', 'width': '100px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'input', 'searchable': true, 'listAdvSearchIndex': 4, 'propType': 'String'}, {'align': 'center', 'field': 'studentId', 'title': '学号', 'width': '140px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'input', 'searchable': true, 'listAdvSearchIndex': 0, 'propType': 'String'}, {'align': 'center', 'field': 'className', 'title': '班级', 'width': '', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'input', 'searchable': true, 'listAdvSearchIndex': 1, 'propType': 'String'}, {'align': 'center', 'field': 'applicationReason', 'title': '说明', 'width': '', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': '', 'searchable': false, 'listAdvSearchIndex': 2, 'propType': 'String', 'elementFormatter': '1：困难家庭（农村、城市低保或特困家庭子女；孤残学生、烈士子女或优抚家庭子女；本人或家庭成员因工伤残或患重大疾病；家庭遭受重大灾害或变故；父母双方或一方残疾，家庭无固定经济来源；单亲家庭、父母年事已高或丧失劳动能力）\n2：涉农专业\n0：农村或县镇户籍'}, {'align': 'left', 'field': 'studentName', 'title': '申请人', 'width': '100px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'input', 'searchable': true, 'listAdvSearchIndex': 4, 'propType': 'String'}, {'align': 'center', 'field': 'flCreateDate', 'title': '创建时间', 'width': '150px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'date', 'searchable': true, 'listAdvSearchIndex': 5, 'propType': 'java.util.Date', 'propFormatter': 'format：yyyy-MM-dd HH:mm', 'elementFormatter': 'format：yyyy\r\n'}, {'align': 'center', 'field': 'wfNodeNames', 'title': '流程状态', 'width': '120px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': 'input', 'searchable': true, 'listAdvSearchIndex': 6, 'propType': 'String'}, {'enabled': false, 'align': 'center', 'field': 'status', 'title': '状态', 'width': '100px', 'sortable': false, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'String', 'elementFormatter': '0：草稿\r\n1：处理中\r\n2：结束\r\n8：已归档\r\n9：已注销\r\n'}, {'enabled': false, 'align': 'center', 'field': 'flContent', 'title': '文件内容', 'width': '100px', 'sortable': false, 'fixed': 'false', 'listTdEdit': 0, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'String'}, {'enabled': false, 'align': 'left', 'field': 'flCreateDept', 'title': '创建部门', 'width': '100px', 'sortable': false, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'String'}, {'enabled': false, 'align': 'center', 'field': 'flCreator', 'title': '创建人', 'width': '85px', 'sortable': false, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'String'}, {'enabled': false, 'align': 'left', 'field': 'flSubject', 'title': '文件标题', 'width': '100px', 'sortable': false, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'String'}, {'enabled': false, 'align': 'center', 'field': 'birthDate', 'title': '出生年月', 'width': '180px', 'sortable': false, 'listAdvSearchElement': '', 'searchable': false, 'propType': 'java.util.Date', 'elementFormatter': 'format：yyyy-MM-dd\r\n'}],
            listStyle: {},
            listpageBtns: [{'id': 'btn_add', 'btnType': 'toolbar', 'btnName': '新增', 'btnIcon': 'plus', 'btnPermission': 'startWflow', 'btnClick': "startWflow('免学费申请');", 'btnI18nCode': 'startWflow'}, {'id': 'btn_export', 'btnType': 'toolbar', 'btnName': '导出', 'btnIcon': 'export.svg', 'btnPermission': 'exportWform', 'btnClick': 'exportWform();', 'btnI18nCode': 'exportWform'}],
            busiformBtns: [],
            formTitle: '免学费申请表',

            classOption: [{id: 'all', text: '全部', value: '全部'}],
            searchObj: {
                classId: '全部',
                className: '全部'
            }

        }
    },
    computed: {
    },
    watch: {
	    $route: function(a, b) {
	    	this.setShowView()
	    }
    },
    created: function() {
        //列表页面配置ID
        this.moduleInfo.listpageViewUrl = '/studentTuitionWaiverApplication/listAllFile.html'
        const _this = this
        this.listpageBtns.forEach(function(btn) {
            btn.btnParams = null
            if (typeof btn.btnClick === 'string') {
                let btnClick = btn.btnClick
                if (btn.btnClick.indexOf('(') !== -1) {
                	let btnParams = btnClick.substring(btnClick.indexOf('(') + 1, btnClick.lastIndexOf(')'))
                	if (btnParams !== '') {
            			btnParams = btnParams.replace(/'/g, '').replace(/ /g, '').split(',')
            			btn.btnParams = btnParams
                	}
                	btnClick = btnClick.split('(')[0]
                }
                if (_this[btnClick]) {
                	btn.btnClick = _this[btnClick]
                }
            }
        })

        this.findClazz()
        this.insertSelectComponent()
    },
    beforeDestroy: function() {
    },
    mounted: function() {
    	this.setShowView()
    },
    methods: {
        insertSelectComponent() {
            debugger
            // 获取目标div
            const targetDiv = document.getElementById('targetDiv')
            if (!targetDiv) return

            // 创建临时容器
            const tempContainer = document.createElement('div')

            // 渲染组件结构（注意：在Vue中更推荐使用组件方式，这里为演示直接生成DOM）
            tempContainer.innerHTML = `
        <div class="select-wrapper">
          <span class="label">班级：</span>
          <el-select 
            v-model="searchObj.classId" 
            placeholder="请选择"
            class="select-component"
          >
            ${classOption.value.map(item => `
              <el-option 
                key="${item.id}" 
                label="${item.text}" 
                value="${item.text}"
              ></el-option>
            `).join('')}
          </el-select>
        </div>
      `

            // 清空目标div并插入新内容
            // targetDiv.innerHTML = ''
            targetDiv.appendChild(tempContainer.firstElementChild)

            // 注意：直接操作DOM不会自动绑定Vue的响应式和事件，
            // 实际项目中推荐使用Vue的动态组件或条件渲染
        },
        setShowView: function() {
            if (this.$route.fullPath.indexOf('itemurl=') !== -1) {
	    		this.showView = 'mainform'
	    	} else {
	    		this.showView = 'listpage'
	    	}
        },
        /**
        * 加载数据准备，qparams为查询参数对象，不需要返回值
        */
        onListDataBeforeLoad: function($scope, qparams) {
        	this.loginUser = $scope.loginUser

            let roles = $scope.$store.getters.roles

            qparams.urlsearch = ''
            if (roles.indexOf('dwAdministrators') === -1 && roles.indexOf('fundingAdministrator') === -1) {
                if (this.classOption.length == 1) {
                    qparams.urlsearch = `className:underfined;`
                } else if (this.classOption.length > 1) {
                    let name = this.classOption.map(item => item.text).join(',')
                    qparams.urlsearch = `className:${name};`
                } else {
                    qparams.urlsearch = `className:underfined;`
                }
            }

            if (this.searchObj.classId && this.searchObj.classId !== '全部') {
                qparams.urlsearch += `className:${this.searchObj.classId}`
            }
            console.log('tuitionWaiverApplication listdata before load..')
        },
        /**
        * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
        */
        onListDataLoaded: function($scope, pageInfo) {
            console.log('tuitionWaiverApplication listdata loaded')
        },
        /**
        * 数据删除成功，ids为已删除成功的tuitionWaiverApplication对象ID数组，即将刷新列表，不需要返回值
        */
        onDeleteSuccessed: function($scope, ids) {
            console.log('tuitionWaiverApplication delete successed')
        },

        openWorkFlow: function(row, column, innerText, cellIndex) {
         	if (row.itemUrl === undefined) {
		      	let wfEngineUrl = this.moduleInfo.listDataUrl.split('/')
		        wfEngineUrl = encodeURI(wfEngineUrl[0] + '/' + wfEngineUrl[1])
                row.itemUrl = '/wflow?wfEngineUrl=' + wfEngineUrl + '&busiDataId=' + row.id
         	}
         	let itemUrl = row.orgCode ? (row.itemUrl + '&orgCode=' + row.orgCode) : row.itemUrl

         	if (window.wflowview == 'appMain') {
         		this.appMainShowWflow(itemUrl)
         	} else {
		        window.open('./#' + itemUrl)
         	}
        },
        /**
		* 发起新流程
		*/
        startWflow: function(wfName, wfNodeName, wfEngineUrl, busiCode) {
            if (wfName === '[流程名称]' && this.moduleInfo.wfName) wfName = this.moduleInfo.wfName
            if (wfNodeName === undefined) wfNodeName = this.moduleInfo.wfNodeName || ''
            if (wfEngineUrl === undefined) {
                if (this.moduleInfo.wfEngineUrl && this.moduleInfo.wfEngineUrl.indexOf('/') !== -1) {
                    wfEngineUrl = this.moduleInfo.wfEngineUrl
                } else {
                    wfEngineUrl = this.moduleInfo.listDataUrl.split('/')
                    wfEngineUrl = encodeURI(wfEngineUrl[0] + '/' + wfEngineUrl[1])
                }
            }
            if (busiCode === undefined) busiCode = this.moduleInfo.busiCode || 'tuitionWaiverApplication'
            let urlParams = 'wfEngineUrl=' + wfEngineUrl + '&busiCode=' + busiCode + '&wfName=' + encodeURI(wfName) + '&startNodeName=' + encodeURI(wfNodeName)

            if (window.wflowview == 'appMain') {
         		this.appMainShowWflow('./#/wflow?' + urlParams)
         	} else {
                window.open('./#/wflow?' + urlParams)
         	}
        },
        /**
		* 右下工作区打开审批单
		*/
        appMainShowWflow: function(itemurl) {
            itemurl = encodeURIComponent(itemurl)
            const wflowpath = location.href.split('#')[1]
            if (wflowpath.indexOf('?') === -1) {
                this.$router.push(wflowpath + '?itemurl=' + itemurl)
            } else if (this.$route.query.itemurl !== undefined) {
                this.$router.replace(wflowpath.replace('itemurl=' + encodeURIComponent(this.$route.query.itemurl), 'itemurl=' + itemurl))
            } else {
                this.$router.push(wflowpath + '&itemurl=' + itemurl)
            }
        },
        /**
		* 批量办文（actionType=todo）、批量阅文（actionType=toread）、批量注销（actionType=writeoff）
		*/
        batchProcessFiles: function(actionType) {
            this.$bus.emit('startBatchProcessFiles', this, actionType)
        },
        /**
		* 关注、取消关注
		*/
        setAttend: function(attend) {
            this.$bus.emit('startBatchProcessFiles', this, 'attend', attend)
        },

        changeHanlde() {
            this.$bus.emit('refreshListData')
        },
        async findClazz() {
            await this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/xsgl/schoolClazz/findClazz`,
                method: 'GET'
            }).then(res => {
                if (res.code === 'success') {
                    var list = res.body.options
                    if (list.length) {
                        this.classOption.push(...list)
                    }
                    setTimeout(() => {
                        this.$bus.emit('refreshListData')
                    }, 300)
                }
            })
        }

    }
}
</script>

<style>
</style>
